import React, { Component } from "react";
import Classnames from "classnames";
import { ReactComponent as TwoNLogo } from "./two-n-logo.svg";
import "./Section.scss";
import Card from "../Card";

import { NestedData, section } from "../../global-interfaces";
import { CHART_TYPES, Sections } from "../../constants";
import TextCard from "../TextCard";
const { TEXT, NESTED_TEXT, HEADLINE } = CHART_TYPES

interface Props {
  data: NestedData;
  sectionIndex: number;
  setSection: Function;
  observer: IntersectionObserver;
  isMobile: boolean;
  isLast: boolean;
}

class Section extends Component<Props> {
  section: section;
  constructor(props: Props) {
    super(props);
    const { title, color, hash, index, path, pathActive } = this.props.data;
    this.section = { title, color, hash, index, path, pathActive };
  }

  render() {
    const { sectionIndex, setSection, observer, isMobile, isLast } = this.props;
    const {
      cards,
      title,
      color,
      hash,
      index,
      path,
      pathActive,
    } = this.props.data;

    return (
      <div 
        className={Classnames("Section", sectionIndex, color)} 
        id={hash}>
        <div className="section-title">{title}</div>
        {cards.map(d => {
          return d.questions[0].chart_type === TEXT ||
            d.questions[0].chart_type === NESTED_TEXT ||
            d.questions[0].chart_type === HEADLINE ? (
            <TextCard
              key={`${sectionIndex}-${d.card}`}
              type={d.questions[0].chart_type}
              data={d.questions[0].data}
              title={d.questions[0].graph_title}
              card={d.questions[0].card}
              section={{ title, color, hash, index, path, pathActive }}
              introCard={
                title === Sections.INTRODUCTION && d.questions[0].chart_type === "text"
              }
              setSection={setSection}
              observer={observer}
            />
          ) : (
            <Card
              key={d.card}
              data={d.questions}
              section={this.section}
              observer={observer}
              isMobile={isMobile}
            />
          );
        })}
        {isLast && (
          <div className="two-n-logo">
            <span>designed and developed by </span>
            <a href="http://two-n.com/" target="_blank" tabIndex={-1}>
              <TwoNLogo />
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default Section;
